import { styled, Text } from "@tamagui/core";
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
const DEFAULT_SIZE = "large",
  InternalHeaderNumber = styled(Text, {
    accessibilityRole: "header",
    color: "$text-primary",
    defaultVariants: {
      size: DEFAULT_SIZE
    },
    fontFamily: "$body",
    fontSize: "$xLarge",
    fontWeight: "500",
    lineHeight: "$xLarge",
    variants: {
      size: {
        large: {
          fontSize: "$xLarge",
          lineHeight: "$xLarge"
        },
        veryLarge: {
          fontSize: "$xxLarge",
          lineHeight: "$xxLarge"
        }
      }
    }
  }),
  HeaderNumberAncestorSizeContext = createContext(void 0);
function HeaderNumber({
  size,
  ...propsWithoutSize
}) {
  const parentSize = useContext(HeaderNumberAncestorSizeContext);
  return parentSize ? /* @__PURE__ */jsx(InternalHeaderNumber, {
    ...propsWithoutSize,
    size: size || parentSize
  }) : /* @__PURE__ */jsx(HeaderNumberAncestorSizeContext.Provider, {
    value: size || DEFAULT_SIZE,
    children: /* @__PURE__ */jsx(InternalHeaderNumber, {
      ...propsWithoutSize,
      size
    })
  });
}
export { HeaderNumber, InternalHeaderNumber };